import { FormHelperText, Stack, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { styled } from '@mui/material/styles'

import * as OrderTexts from '../../../../intl'

import { PickupAndDeliveryDivisionOption } from '../typings'

type Props = {
  onChange: (value: 'p' | 'd') => void
  value: 'p' | 'd'
  options: PickupAndDeliveryDivisionOption[]
}

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  flex: 1,
  border: '1px solid rgba(0, 0, 0, 0.12) !important',
  '&:not(:first-of-type)': {
    borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
    marginLeft: 0,
  },
  '&.Mui-selected': {
    backgroundColor: '#1565C014',
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: '#1565C014',
    },
  },
}))

export function OrderStepTypeDivision(props: Props) {
  const { onChange, value, options } = props

  return (
    <Stack direction="column">
      <ToggleButtonGroup value={value} exclusive sx={{ gap: 2 }}>
        {options.map(option => (
          <StyledToggleButton
            value={option.value}
            aria-label={option.label}
            disabled={option.disabled}
            onClick={() => onChange(option.value)}
            data-testid={
              option.value === 'p' ? 'order-step-type-pickup' : 'order-step-type-dropoff'
            }
          >
            {option.label}
          </StyledToggleButton>
        ))}
      </ToggleButtonGroup>

      <FormHelperText>{OrderTexts.getPickupAndDeliveryTypeHelperText()}</FormHelperText>
    </Stack>
  )
}
